<template>
  <div>
    <div>
      <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
      <h3 class="mt-3">
        {{ $getVisibleNames("mesh.mattertype", true, "Tipos de Asignatura") }}
        <AlternativeNameButton
          :table_name="'mesh.mattertype'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_mattertype'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.mattertype',
                  false,
                  'Tipo De Asignatura'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-matter-type-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
          <!-- Tipo de Asignatura -->
        </div>
      </div>
      <GenericBTable
        v-if="searchMatterType.length > 0"
        class="matter-type-table"
        :items="matter_types"
        :pagination="matter_types.length"
        :fields="matterTypesFields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="display_id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.mattertype',
                  false,
                  'Tipo De Asignatura'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-matter-type-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            :click_button="() => askForDeleteMatterType(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.mattertype',
                  false,
                  'Tipo De Asignatura'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-matter-type-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.mattertype',
                  false,
                  'Tipo De Asignatura'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <MatterTypeForm
              :MatterType="row.item"
              @updated="slotUpdatedMatterType"
              :institution_id="row.item.school"
              :show_title="false"
            ></MatterTypeForm>
          </b-modal>
        </template>
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
      </GenericBTable>
      <div v-else>
        <br />
        <!-- tipo de asignatura -->
        <strong
          >{{ $t("reusable.common.noDataFound") }}
          {{
            $getVisibleNames(
              "mesh.mattertype",
              false,
              "Tipo De Asignatura"
            ).toLowerCase()
          }}.</strong
        >
      </div>
    </div>
    <b-modal
      :id="`new-matter-type-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.mattertype',
            false,
            'Tipo De Asignatura'
          ),
        })
      "
      size="lg"
    >
      <MatterTypeForm
        v-if="user"
        @created="slotCreatedMatterType"
        :show_title="false"
        :institution_id="user.school"
      ></MatterTypeForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";
export default {
  name: "MatterTypeView",
  components: {
    MatterTypeForm: () =>
      import("@/components/mesh/CurricularResources/MatterType/MatterTypeForm"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    input_search: {
      type: String,
      default: "",
    },
    display_id: {},
  },
  data() {
    return {
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      matter_types: names.MATTER_TYPES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.mattertype",
            true,
            "Tipos de Asignatura"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_mattertype");
      if (has_permission) return has_permission;
      else return false;
    },
    matter_types_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.mattertype",
              true,
              "Tipos de Asignatura"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: String(this.$t("reusable.common.description")),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
    searchMatterType: function () {
      return this.matter_types
        .filter((item) => {
          return (
            item.name.toLowerCase().includes(this.input_search.toLowerCase()) ||
            item.description
              .toLowerCase()
              .includes(this.input_search.toLowerCase())
          );
        })
        .sort(function (a, b) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
    },
    matterTypesFields() {
      if (!this.allows_crud)
        return this.matter_types_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.matter_types_fields;
    },
  },
  methods: {
    askForDeleteMatterType(matter_type_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.mattertype",
            false,
            "Tipo De Asignatura"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_MATTER_TYPE, matter_type_id)
            .then(() => {
              toast(
                String(
                  this.$getVisibleNames(
                    "mesh.mattertype",
                    false,
                    "Tipo De Asignatura"
                  ) +
                    " " +
                    this.$t("reusable.common.deleted")
                )
              );
            });
        }
      });
    },
    slotCreatedMatterType() {
      this.$bvModal.hide("new-matter-type-modal");
    },
    slotUpdatedMatterType(matter_type) {
      this.$bvModal.hide(`edit-matter-type-modal-${matter_type.id}`);
    },
  },
  mounted() {
    this.$store.dispatch(names.FETCH_MATTER_TYPES);
  },
  created() {},
};
</script>

<style scoped>
.td-actions {
  max-width: 100px !important;
}
.title-header {
  padding: 0 1rem;
  margin-top: auto;
}
.search-matter-type {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
</style>